const openedPaymentPage = {
  fawry: {
    title: '¡Tu pago ha sido creado!',
    importantMessage: {
      title: 'Es importante saberlo',
      description: 'Puede pagar con el número de referencia a través de cualquiera de los canales o puntos de venta de Fawry o a través de la app de Fawry. Para evitar la cancelación del pedido, complete el proceso de pago dentro del plazo indicado.',
    },
    orderDetail: {
      expirationDate: 'Fecha de vencimiento del pago:',
      totalAmount: 'Montante total',
    },
    referenceNumber: {
      title: 'Número de referencia',
      copy: 'Copiar',
      copied: 'Copiada!',
    },
  },
  customer: {
    form: {
      fieldCustomerBirthdate: {
        label: 'Fecha de nacimiento',
        validationMessage: {
          empty: 'Indique su fecha de nacimiento',
          invalid: 'Fecha de nacimiento inválida',
          serverError: 'Error del servidor. Inténtelo de nuevo más tarde.',
        },
      },
    },
  },
  cryptocurrency: {
    disclaimer1: 'Los pagos con criptomonedas son procesados únicamente por proveedores terceros con licencia, no por EBANX. Los detalles de los proveedores, incluyendo su respectiva licencia y estado regulatorio, se detallan en los ',
    termsAndConditions: 'Términos y Condiciones',
    disclaimer2: ' aplicables.',
    merchantInfo: {
      returnButton: 'Puedes cancelar esta orden y regresar para elegir un medio de pago distinto.',
      backTo: 'Cancelar y volver',
    },
  },
};

module.exports = openedPaymentPage;
